import React from 'react'
import { WContainer, EditableTitle } from '@components/atoms'
import styles from './PluspointSection.module.sass'
import { PlusPointNode } from '@gql/graphql'
import useTrans from '@hooks/useTrans'
import { PDPInfoCard } from '@components/molecules'
import { Swiper, SwiperSlide } from 'swiper/react'
import { A11y, Pagination } from 'swiper/modules'

interface Props {
  plusPoints: PlusPointNode[]
  editMode?: boolean
  className?: string
  nextImage?: boolean
}

const PluspointSection = (props: Props) => {
  const { plusPoints = [], className = '', nextImage = false } = props

  const t = useTrans()

  return plusPoints.length ? (
    <div className={`${styles.root} ${className}`}>
      <WContainer>
        <div className={`${styles.layout}`}>
          <div className={styles.main}>
            <div className={styles.content}>
              <EditableTitle title={t('Plus point')} variant="h2" className={styles.title} />
            </div>
          </div>

          <div className={`${styles.list}`}>
            {plusPoints?.map((x) => (
              <PDPInfoCard
                variant="light"
                item={{
                  ...x,
                  name: x.titolo,
                  description: x.descrizione,
                  image: x.immagine,
                }}
                key={x.pk}
                className={styles.item}
              />
            ))}
          </div>

          {!!Array.isArray(plusPoints) && plusPoints?.length && (
            <div className={styles.slider}>
              <Swiper
                spaceBetween={20}
                slidesPerView={1.1}
                watchOverflow
                modules={[Pagination, A11y]}
                pagination={{
                  type: 'progressbar',
                }}
                breakpoints={{
                  576: { slidesPerView: 2.1 },
                }}
              >
                {plusPoints.map((n, index) => (
                  <SwiperSlide key={index}>
                    <PDPInfoCard
                      variant="light"
                      item={{
                        ...n,
                        name: n.titolo,
                        description: n.descrizione,
                        image: n.immagine,
                      }}
                      key={n.pk}
                      nextImage={nextImage}
                      className={styles.item}
                    />
                  </SwiperSlide>
                ))}
              </Swiper>
            </div>
          )}
        </div>
      </WContainer>
    </div>
  ) : (
    <></>
  )
}

export default PluspointSection
